import axios from 'axios';
import config from '@/config/env-constants';


export default {
    baseUrl: 'https://us-central1-ayun-quantity-' + config.currEnv + '.cloudfunctions.net',

    getStorageLocations(filterBy, view, currUserId) {
        const url = `${this.baseUrl}/getStorageLocations`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy)
        });
    },

    saveStorageLocation(storageLocation, currUserId, currTimeStamp) {
        const url = `${this.baseUrl}/saveStorageLocation`;
        return axios.post(url, {
            currUserId: currUserId,
            currTimeStamp: currTimeStamp,
            storageLocation: JSON.stringify(storageLocation)
        });
    },

}